module.exports = __webpack_public_path__ + "static/Gibson-SemiBold-webfont-9587ccacf1f4d895e12ca700d324ee70.eot";